// extracted by mini-css-extract-plugin
export default {"createBtnWrap":"TaskList_createBtnWrap__Gjpfs","plusIcon":"TaskList_plusIcon__-kbRj","submitBtn":"TaskList_submitBtn__LXNWM"};